var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[(_vm.$route.name == 'Sign In')?_c('SignIn'):_vm._e(),(_vm.$route.name == 'Sign Up')?_c('SignUp'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }